import {
    type DataSourceType,
    type ShiftNoteRead,
} from '@libraries/typescript/api_client';

export type SupportedShiftNoteSource = Extract<
    DataSourceType,
    'alayacare' | 'axiscare' | 'wellsky'
>;

export function isSupportedShiftNoteSource(
    sourceSystem: DataSourceType,
): sourceSystem is SupportedShiftNoteSource {
    return (
        sourceSystem === 'alayacare' ||
        sourceSystem === 'axiscare' ||
        sourceSystem === 'wellsky'
    );
}

// Match the source EHR's name for the overall note surface.
export function shiftNoteSurfaceLabel(
    sourceSystem: SupportedShiftNoteSource | null,
): string {
    return sourceSystem === 'axiscare' ? 'Memo' : 'Notes';
}

// WellSky shows ordinary notes and activity notes as separate sections.
export const WELLSKY_NOTE_KIND_SECTIONS: ReadonlyArray<{
    readonly kind: ShiftNoteRead['note_kind'];
    readonly label: string;
}> = [
    { kind: 'shift', label: 'Notes' },
    { kind: 'activity', label: 'Activity Notes' },
];

// AxisCare calls this field "Internal Memo" inside mixed-source note lists.
export const AXISCARE_MEMO_SECTION_LABEL = 'Internal Memo';
// AlayaCare calls them plain notes and has no kinds, so one heading covers
// them — unlike WellSky, which splits shift and activity notes.
export const ALAYACARE_NOTE_SECTION_LABEL = 'Notes';

const WELLSKY_NOTE_LABEL_BY_KIND: Record<ShiftNoteRead['note_kind'], string> = {
    shift: 'Note',
    activity: 'Activity note',
};

export function shiftNoteItemLabel(note: ShiftNoteRead): string {
    if (note.source_system === 'axiscare') {
        return 'Memo';
    }
    return WELLSKY_NOTE_LABEL_BY_KIND[note.note_kind];
}
